export enum Layout {
  GRID = 'grid',
  LIST = 'list',
}
